export const constantes = {
  localStorage: {
    menuAdministrador: 'menuAdministrador',
    menuConsultora: 'menuconsultora',
    menu: 'menu',
    retornarMenuMini: 'retornarMenuMini',
    visualizandoLoja: 'adminVisualizandoLoja',
    afiliadoId: 'afiliadoId',
    afiliadoNome: 'afiliadoNome',
    jwtToken: 'jwtToken',
    temaSelecionado: 'tema-selecionado',
    sideNavOpen: 'sidenav-open',
    dominioLoja: 'dominioLoja'
  }
};
